// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3x7A6","inner":"Footer_inner__3Xghd"};